import React, { useState, useEffect } from 'react';
import { Modal, Form, Select, Button, message, Alert } from 'antd';
import { useAssetActions } from '../../../../hooks/useAssets';
import { Asset, AssetStatus } from '../../../../types/asset.types';

const { Option } = Select;

interface UpdateAssetModalProps {
  visible: boolean;
  onClose: () => void;
  onSuccess: () => void;
  asset: Asset | null;
}

const UpdateAssetModal: React.FC<UpdateAssetModalProps> = ({
  visible,
  onClose,
  onSuccess,
  asset
}) => {
  const [form] = Form.useForm();
  const { updateAssetStatus, isLoading } = useAssetActions();

  useEffect(() => {
    if (visible && asset) {
      form.setFieldsValue({
        status: asset.status
      });
    }
  }, [visible, asset, form]);

  const handleSubmit = async (values: any) => {
    if (!asset) return;
    
    try {
      await updateAssetStatus(asset.id, {
        status: values.status
      });
      onSuccess();
      form.resetFields();
    } catch (error) {
      console.error('Update asset status failed:', error);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  const getStatusText = (status: AssetStatus) => {
    switch (status) {
      case AssetStatus.ASSIGNED:
        return 'Atanmış';
      case AssetStatus.RETURNED:
        return 'İade Edildi';
      default:
        return status;
    }
  };

  if (!asset) return null;

  return (
    <Modal
      title="Zimmet Durumu Güncelle"
      open={visible}
      onCancel={handleCancel}
      footer={null}
      destroyOnClose
    >
      <div className="mb-3">
        <Alert
          message={
            <div>
              <strong>{asset.name}</strong> ({asset.serialNumber})
              <br />
              <small className="text-muted">
                Mevcut durum: {getStatusText(asset.status)}
              </small>
            </div>
          }
          type="info"
          showIcon
        />
      </div>

      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        autoComplete="off"
      >
        <Form.Item
          name="status"
          label="Yeni Durum"
          rules={[
            { required: true, message: 'Durum seçimi gereklidir' }
          ]}
        >
          <Select placeholder="Durum seçin">
            <Option value={AssetStatus.ASSIGNED}>Atanmış</Option>
            <Option value={AssetStatus.RETURNED}>İade Edildi</Option>
          </Select>
        </Form.Item>

        <Form.Item className="mb-0">
          <div className="d-flex justify-content-end gap-2">
            <Button onClick={handleCancel}>
              İptal
            </Button>
            <Button type="primary" htmlType="submit" loading={isLoading}>
              Güncelle
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UpdateAssetModal; 